export default {
  components: {
    stationSelector: {
      title: '车站选择'
    },
    datePicker: {
      title: '日期选择'
    }
  },
  dashboard: {
    title: '仪表盘'
  }
};
